import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import MenuListItems from "./AdminCenterMenuListItems";
import { styled, useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import useMediaQuery from "@mui/material/useMediaQuery";
import PerfectScrollBar from "react-perfect-scrollbar";
import AdminCenterDesktopAppBar from "./AdminCenterDesktopAppBar";
import AdminCenterMobileAppBar from "./AdminCenterMobileAppBar";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const drawerWidth = 240;

export default function AdminCenterSideBar(props) {
  const { children } = props;
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [open, setOpen] = React.useState(true);
  const matchesMd = useMediaQuery(theme.breakpoints.up("md"));

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Box>
        {matchesMd ? (
          <Box
            sx={{
              display: "flex",
            }}
          >
            <CssBaseline />
            <AdminCenterDesktopAppBar
              drawerWidth={drawerWidth}
              open={open}
              handleDrawerOpen={handleDrawerOpen}
            />
            <Drawer
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": {
                  width: drawerWidth,
                  boxSizing: "border-box",
                },
              }}
              variant="persistent"
              anchor="left"
              open={open}
            >
              <DrawerHeader>
                <IconButton onClick={handleDrawerClose}>
                  {theme.direction === "ltr" ? (
                    <CloseRoundedIcon />
                  ) : (
                    <CloseRoundedIcon />
                  )}
                </IconButton>
              </DrawerHeader>
              <Divider />
              <PerfectScrollBar component="div">
                <MenuListItems handleDrawerClose={handleMobileDrawerToggle} />
              </PerfectScrollBar>
            </Drawer>
            <Main open={open}>
              <DrawerHeader />
              {children}
            </Main>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
            }}
          >
            <CssBaseline />
            <AdminCenterMobileAppBar
              handleMobileDrawerOpen={handleMobileDrawerToggle}
              mobileOpen={mobileOpen}
            />
            <Drawer
              variant="temporary"
              anchor="left"
              open={mobileOpen}
              ModalProps={{
                keepMounted: true,
              }}
              onClose={handleMobileDrawerToggle}
            >
              <DrawerHeader>
                <IconButton onClick={handleMobileDrawerToggle}>
                  {theme.direction === "ltr" ? (
                    <CloseRoundedIcon />
                  ) : (
                    <CloseRoundedIcon />
                  )}
                </IconButton>
              </DrawerHeader>
              <Divider />
              <MenuListItems handleDrawerClose={handleMobileDrawerToggle} />
            </Drawer>
            <Box
              component="main"
              sx={{
                margin: "10px",
              }}
            >
              <DrawerHeader />
              {children}
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
}
